
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 14a2 2 0 012 2v9a2 2 0 01-2 2H7a2 2 0 01-2-2v-9a2 2 0 012-2h18zm0 1H7a1 1 0 00-.993.883L6 16v9a1 1 0 00.883.993L7 26h18a1 1 0 00.993-.883L26 25v-9a1 1 0 00-.883-.993L25 15zm-2 6a1 1 0 110 2 1 1 0 010-2zM8.5 22a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zM8 11v1H7a1 1 0 00-.993.883L6 13v.268a2 2 0 00-.993 1.563L5 15v-2a2 2 0 012-2h1zm17 0a2 2 0 012 2v2a2 2 0 00-.999-1.732L26 13a1 1 0 00-.883-.993L25 12l-1-.001V11h1zm-4-5c.08 0 .16.005.238.014l.098-.009L21.5 6a2.5 2.5 0 011.501 4.5L23 13H9v-2.5a2.5 2.5 0 011.763-4.487C10.84 6.006 10.92 6 11 6h10zm.532 1L21.424 7l-.098.01-.206-.004-.06-.005H10.94l-.061.005-.219.001a1.5 1.5 0 00-1.178 2.593l.12.1.4.3L9.998 12H22l.001-2 .399-.3c.376-.282.6-.722.6-1.2a1.5 1.5 0 00-1.329-1.494L21.532 7z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    